import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import MoreInfo from './pages/MoreInfo';
import CookiePolicy from './pages/CookiePolicy';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <Header />
        <main className="flex-grow">
          <div className="max-w-4xl mx-auto px-4 py-12 text-gray-900">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/more-info" element={<MoreInfo />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
            </Routes>
          </div>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
